import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {DatasetModel} from '../views/models/dataset.model';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DatasetService {
  record_change$ = new BehaviorSubject<DatasetModel[]>([new DatasetModel()]);
  itemChart = new BehaviorSubject<DatasetModel[]>([new DatasetModel()]);
  areachart = new BehaviorSubject<DatasetModel[]>([new DatasetModel()]);
  rateChart = new BehaviorSubject<DatasetModel[]>([new DatasetModel()]);
  durationChart = new BehaviorSubject<DatasetModel[]>([new DatasetModel()]);
  pointChart = new BehaviorSubject<DatasetModel[]>([new DatasetModel()]);
  priceChart = new BehaviorSubject<DatasetModel[]>([new DatasetModel()]);
  pieChart = new BehaviorSubject<any[]>([]);
  pieChartWorker = new BehaviorSubject<any[]>([]);
  workerChart = new BehaviorSubject<DatasetModel[]>([new DatasetModel()]);
  issuesChart = new BehaviorSubject<DatasetModel[]>([new DatasetModel()]);
  surveyChart = new BehaviorSubject<DatasetModel[]>([new DatasetModel()]);

  workers = new BehaviorSubject<string[]>([]);
  languages = new BehaviorSubject<string[]>([]);
  hotels = new BehaviorSubject<string[]>([]);
  guests = new BehaviorSubject<string[]>([]);
  subs = new BehaviorSubject<string[]>([]);
  auto = new BehaviorSubject<boolean>(false);

  constructor(private httpClient: HttpClient) {
  }

  getData() {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/report_dataset').subscribe(
      (data: DatasetModel[]) => {
        data.forEach(x => {
          x.date = new Date(x.date);
          x.date = new Date(x.date.getFullYear(), x.date.getMonth(), x.date.getDate());
        });
        this.record_change$.next(data);
        const workers = new Set(data.filter(x => x.worker != '').map(x => x.worker));
        const worker = [];
        workers.forEach(x => {
          worker.push(x);
        });
        this.workers.next(worker);
        const languages = new Set(data.filter(x => x.language != '').map(x => x.language));
        const language = [];
        languages.forEach(x => {
          language.push(x);
        });
        this.languages.next(language);
        const hotels = new Set(data.filter(x => x.hotel != '').map(x => x.hotel));
        const hotel = [];
        hotels.forEach(x => {
          hotel.push(x);
        });
        this.hotels.next(hotel);
        const guests = new Set(data.filter(x => x.profile_name != '').map(x => x.profile_name));
        const guest = [];
        guests.forEach(x => {
          guest.push(x);
        });
        this.guests.next(guest);
        const subs = new Set(data.filter(x => x.sub != '').map(x => x.sub));
        const sub = [];
        subs.forEach(x => {
          sub.push(x);
        });
        this.subs.next(sub);

        this.getDataWithInterval('month', '', '', '', '', '', this.auto.getValue());
      }
    );
  }

  getDataWithInterval(interval, worker: string, language: string, hotel: string, item: string, guest: string, auto ?: boolean) {
    let date: Date = new Date();
    switch (interval) {
      case 'day':
        date = new Date(date.setDate(date.getDate() - 1));
        break;
      case 'week':
        date = new Date(date.setDate(date.getDate() - 7));
        break;
      case 'month':
        date = new Date(date.setDate(date.getDate() - 30));
        break;
      case '3month':
        date = new Date(date.setDate(date.getDate() - 90));
        break;
    }
    let data = this.record_change$.getValue().filter(x => new Date(x.date) >= date);
    if (!this.auto.getValue()) {
      data = data.filter(x => x.worker != 'Auto');
    }
    if (worker) {
      data = data.filter(x => x.worker == worker);
    }
    if (language) {
      data = data.filter(x => x.language == language);
    }
    if (item) {
      data = data.filter(x => x.sub == item);
      this.itemChart.next(data);
    }
    if (guest) {
      data = data.filter(x => x.profile_name == guest);
    }

    this.areachart.next(data);
    this.rateChart.next(data.filter(x => x.rating != 0 && x.sub != ''));
    this.durationChart.next(data.filter(x => x.sub != '' && x.duration != 0));
    this.pointChart.next(data.filter(x => x.point != 0 && x.sub != ''));
    this.priceChart.next(data.filter(x => x.price != 0 && x.item != '' && x.worker != ''));
    this.workerChart.next(data.filter(x => x.worker != ''));
    this.issuesChart.next(data.filter(x => x.sub == 'Arıza' && x.item != ''));
    this.surveyChart.next(data.filter(x => x.reason_type == 'survey' && x.rating != 0));
  }

  getPieChart(interval, query ?: string) {
    if (!this.auto.getValue() && query != '') {
      query += '&auto=false';
    }
    if (!this.auto.getValue() && query == '') {
      query += '?auto=false';
    }
    this.httpClient.get(environment.baseURL + '/v2/api' + '/report_pie/' + interval + query).subscribe(
      (data: any[]) => {
        this.pieChart.next(data);
      }, (err) => {
        console.log(err);
      }
    );
  }

  getPieChartGroupWorker(interval) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/report_pie_worker/' + interval).subscribe(
      (data: any[]) => {
        let index = data.findIndex(x => x.worker == '');
        data.splice(index, 1);
        if (!this.auto.getValue()) {
          index = data.findIndex(x => x.worker == 'Auto');
          data.splice(index, 1);
        }
        this.pieChartWorker.next(data);
      }
    );
  }

  getDataByItemId(id: number) {
    this.record_change$.subscribe(
      () => {
        this.itemChart.next(this.record_change$.getValue().filter(x => x.item_id == id));
      });
  }
}
